import { render, staticRenderFns } from "./storage-register-list.vue?vue&type=template&id=5e86216c&"
import script from "./storage-register-list.vue?vue&type=script&lang=js&"
export * from "./storage-register-list.vue?vue&type=script&lang=js&"
import style0 from "./storage-register-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports